module.exports = __webpack_public_path__ + "img/box-checkmark.7f6d3b25.svg";